import React from "react";

const Input = ({ name, label, error, ...rest }) => {
  if (rest?.type === "textarea") {
    return (
      <div className="input-wrapper">
        <textarea
          id={name}
          name={name}
          className={error && "error"}
          {...rest}
        ></textarea>
      </div>
    );
  }

  return (
    <div className="input-wrapper">
      <input id={name} name={name} className={error && "error"} {...rest} />
    </div>
  );
};

export default Input;
